import $ from "jquery";
import { debounce } from "../utils/functions";

const $window = $(window);
const swipeTreshold = { x: 30, y: 30 };
const loadDelay = 500;
const LOADING_CLASS = "about-timeline-carousel--loading";

const PREV = "prev";
const NEXT = "next";

const carousel = (el, index) => {
  const data = {
    cardWidth: 0,
    startMousePos: { x: -1, y: -1 },
    endMousePos: { x: -1, y: -1 },
    direction: "",
    el: el,
    slider: el.find(".about-timeline-carousel__slider"),
    prev: el.find(".about-timeline-carousel__controls-image--prev"),
    next: el.find(".about-timeline-carousel__controls-image--next"),
    cards: el.find(".about-timeline-card"),
    transition: el.find(".about-timeline-carousel__slider").css("transition"),
  };

  $window.off(`resize:width.about-timeline${index}`);
  data.prev.off("click");
  data.next.off("click");
  data.slider.off("transitionend");
  el.off("touchstart touchend");

  if (data.cards.length) {
    setTimeout(() => init(data), 500);

    $window.on(
      `resize:width.about-timeline${index}`,
      debounce(() => data.el.addClass(LOADING_CLASS), true, loadDelay)
    );
    $window.on(
      `resize:width.about-timeline${index}`,
      debounce(() => init(data), false, loadDelay)
    );

    data.prev.on("click", () => slidePrev(data));
    data.next.on("click", () => slideNext(data));
    data.slider.on("transitionend", () => afterSlide(data));
    el.on("touchstart", (event) => onTouchStart(event, data));
    el.on("touchend", (event) => onTouchEnd(event, data));
  }
};

const init = (data) => {
  data.cards.removeAttr("style");
  data.cardWidth = data.cards.outerWidth(true);

  if (data.cardWidth >= $window.width() / 2) {
    const width = data.slider.width();
    data.cards.css({
      "min-width": width,
      "max-width": width,
    });
    data.cardWidth = data.cards.outerWidth(true);
  }

  data.slider
    .parent()
    .scrollLeft(data.cardWidth * Math.floor(data.cards.length / 2));

  data.el.removeClass(LOADING_CLASS);
};

const slidePrev = (data) => {
  data.slider.css("transform", `translate(${data.cardWidth}px)`);
  data.direction = PREV;
};

const slideNext = (data) => {
  data.slider.css("transform", `translate(-${data.cardWidth}px)`);
  data.direction = NEXT;
};

const afterSlide = (data) => {
  const child =
    data.direction === NEXT
      ? data.slider.children().first()
      : data.slider.children().last();

  if (child.length) {
    data.direction === NEXT
      ? data.slider.append(child)
      : data.slider.prepend(child);

    data.slider.css({
      transition: "none",
      transform: "translate(0)",
    });
    setTimeout(() => data.slider.css("transition", data.transition));
  }
};

const onTouchStart = (event, data) => {
  const evt =
    typeof event.originalEvent === undefined ? event : event.originalEvent;
  const touch = evt.touches[0] || evt.changedTouches[0];
  data.startMousePos.x = touch.pageX;
  data.startMousePos.y = touch.pageY;
};

function onTouchEnd(event, data) {
  const evt =
    typeof event.originalEvent === undefined ? event : event.originalEvent;
  const touch = evt.touches[0] || evt.changedTouches[0];
  data.endMousePos.x = touch.pageX;
  data.endMousePos.y = touch.pageY;

  const mousePosDiff = {
    x: data.startMousePos.x - data.endMousePos.x,
    y: data.startMousePos.y - data.endMousePos.y,
  };

  data.startMousePos = { x: -1, y: -1 };
  data.endMousePos = { x: -1, y: -1 };

  if (Math.abs(mousePosDiff.x) > swipeTreshold.x) {
    mousePosDiff.x > 0
      ? data.next.trigger("click")
      : data.prev.trigger("click");
  }
}

export const reloadScriptAboutTimeline = () => {
  const el = $(".about-timeline-carousel");
  el.addClass(LOADING_CLASS);

  el.each(function (index) {
    carousel($(this), index);
  });
};
reloadScriptAboutTimeline();
